module.exports = __webpack_public_path__ + "img/c2-3.2f73dcf0.png";